export const CONCURRENT_KEY = 'concurrents'
export const REGION_KEY = 'regions'
export const CONCURRENT_REGION_KEY = 'concurrent_regions'
export const GROUP_TYPES_KEY = 'group_types_regions'
export const OBJECT_TYPES_KEY = "object_types_key"